import { StatoCaricamento } from '@services/video.service';

/**
 * Scritta del pulsante mentre un video viene caricato.
 *
 * Le fasi vanno distinte: chi manda 150 MB da una linea lenta deve vedere che
 * qualcosa si muove, e quando il file e' arrivato deve capire che ora sta
 * lavorando il server, altrimenti sembra tutto fermo e riprova da capo.
 */
export function etichettaVideo(stato: StatoCaricamento | null): string {
  if (stato === null) {
    return 'Carica video';
  }
  switch (stato.fase) {
    case 'carico':
      return `Carico... ${stato.percentuale}%`;
    case 'in-coda':
      return `In coda, ${stato.davanti} video prima di questo`;
    case 'converto':
      return `Converto... ${stato.percentuale}%`;
    default:
      return 'Carica video';
  }
}
